import request from '@/utils/request'

// v80w1010List
export function v80w1010List(param) {
    let data = param
    return request({
      url: `/v80/v80w1010/v80w1010List`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }

  // getWeldingKind
export function getWeldingKind(param) {
    let data = param
    return request({
      url: `/v80/v80w1010/getWeldingKind`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }

  // getWeldingProcess
export function getWeldingProcess(param) {
    let data = param
    return request({
      url: `/v80/v80w1010/getWeldingProcess`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }

  // getBaseMetal
export function getBaseMetal(param) {
    let data = param
    // console.log('data', data);
    
    return request({
      url: `/v80/v80w1010/getBaseMetal`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }

  // getFileMetal
export function getFileMetal(param) {
    let data = param
    return request({
      url: `/v80/v80w1010/getFileMetal`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }

  // getWorkGroup
export function getWorkGroup(param) {
    let data = param
    return request({
      url: `/v80/v80w1010/getWorkGroup`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }